export default {
  "dashboard": "Tableau de bord",
  "account": "Compte",
  "currentBalance": "Solde actuel",
  "balanceUnavailable": "Solde indisponible",
  "balanceLoading": "Chargement du solde",
  "lastUpdated": "Dernière mise à jour",
  "monthlyBillHelp": "Ces frais seront inclus dans votre facture mensuelle.",
  "billingPeriod": "Période de facturation",
  "currentMonth": "Mois en cours",
  "billableItems": "Éléments facturables",
  "payBalance": "Régler le solde actuel",
  "settleHelp": "Réglez votre solde actuel en ligne en toute sécurité.",
  "autoRefreshHelp": "Votre solde sera actualisé automatiquement après confirmation du paiement.",
  "retry": "Réessayer",
  "noCharges": "Vous n’avez aucuns frais en cours.",
  "clearHelp": "Votre compte est à jour pour la période de facturation en cours.",
  "statementItems": "Éléments du relevé actuel",
  "includedThisMonth": "Inclus dans la facture de ce mois",
  "preparingCheckout": "Préparation du paiement sécurisé…",
  "paymentsDisabled": "Les paiements en ligne ne sont pas encore activés pour ce club.",
  "paymentsSetup": "Le club configure actuellement les paiements en ligne.",
  "paymentReceived": "Paiement reçu. Le solde de votre compte est à jour.",
  "statementUpdating": "Paiement reçu. Votre relevé est en cours de mise à jour.",
  "paymentCancelled": "Le paiement a été annulé. Aucun montant n’a été prélevé.",
  "allowPopups": "Veuillez autoriser les fenêtres contextuelles pour ouvrir le paiement sécurisé dans un nouvel onglet.",
  "checkoutOpened": "Le paiement sécurisé s’est ouvert dans un nouvel onglet.",
  "checkoutFailed": "Impossible de préparer le paiement sécurisé. Veuillez réessayer dans quelques instants.",
  "items": "Articles : {count}",
  "itemsMany": "Articles : {count}",
  "refreshing": " · Actualisation",
  "loadFailed": "Impossible de charger votre solde. Veuillez réessayer.",
  "unknownStatus": "Statut indisponible",
  "noBalanceDue": "Aucun solde à régler.",
  "balanceUnconfirmed": "Impossible de confirmer votre solde actuel. Veuillez actualiser votre compte.",
  "currencyUnavailable": "La devise du paiement en ligne est indisponible. Veuillez contacter le club."
}
